export default __webpack_public_path__ + "static/media/down.71ff2791.svg";